module.exports = __webpack_public_path__ + "static/media/21.55c1d68b.mp3";